import React, { Component } from "react";
import MultipleValueTextInput from "react-multivalue-text-input";
import { onChange, validateForm } from "../../utils";

export default class forward extends Component {
  constructor(props) {
    super();
    this.state = {
      to: { name: "to", value: [], error: "", isRequired: props.hideTo ? false : true },
      subject: { name: "subject", value: "", error: "", isRequired: false },
      body: { name: "body", value: "", error: "", isRequired: true },
    };
  }
  onChange = (e) => {
    const { name, value } = e.target;
    onChange(this, name, value);

  };
  onChangeInput = (item, allItem) => {
    onChange(this, "to", allItem);
  };

  onSubmit = (e) => {
    e.preventDefault();
    if (validateForm(this)) {
      const { to, subject, body } = this.state;
      const model = {
        to: to.value,
        subject: subject.value,
        body: body.value,
      };

      console.log(model, "model");
      this.props.onSubmit(model);
    }
  };

  render() {
    const { to, subject, body } = this.state;
    return (
      <React.Fragment>
        <form onSubmit={this.onSubmit}>
          {!this.props.hideTo && <div>
            <MultipleValueTextInput
              className="form-input"
              onItemAdded={(item, allItem) => this.onChangeInput(item, allItem)}
              onItemDeleted={(item, allItem) =>
                this.onChangeInput(item, allItem)
              }
              // label='To:'
              name="to"
              // name={to.name}
              style={{ border: "none" }}
              placeholder="To"

            // value={to.value}
            />
          </div>}
          {!this.props.hideTo && <hr />}
          <div>
            <input
              className="form-input"
              type="text"
              name={subject.name}
              value={subject.value}
              onChange={this.onChange}
              style={{ width: "95%", border: "none" }}
              placeholder="Subject    "
            />
          </div>
          <hr />
          <div className="d-flex">
            <textarea
              type="text"
              className="form-input "
              name={body.name}
              value={body.value}
              onChange={this.onChange}
              height={3}
              style={{ width: "95%", border: "none" }}
              placeholder="Body"
            />
          </div>
          <div className="d-flex justify-content-between mt-3">
            <button className="btn btn-primary" type="submit">
              Send
            </button>
            <button
              className="btn btn-danger"
              type="cancel"
              onClick={this.props.toggleModal}
            >
              Cancel
            </button>
          </div>
        </form>
      </React.Fragment>
    );
  }
}
